import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-9b9dfbc4")

_pushScopeId("data-v-9b9dfbc4")
const _hoisted_1 = { class: "main__section" }
const _hoisted_2 = { class: "form__input" }
const _hoisted_3 = { class: "input__purpose" }
const _hoisted_4 = { class: "input__purpose-other" }
const _hoisted_5 = {
  for: "purpose",
  class: "-medium"
}
const _hoisted_6 = { class: "-required" }
const _hoisted_7 = { class: "input__files" }
const _hoisted_8 = {
  for: "purpose",
  class: "-medium"
}
const _hoisted_9 = {
  key: 0,
  class: "request__footer"
}
const _hoisted_10 = { class: "footer__doctor" }
const _hoisted_11 = { class: "label -medium" }
const _hoisted_12 = { class: "value -bold" }
const _hoisted_13 = { class: "footer__datetiem" }
const _hoisted_14 = { class: "value -bold" }
const _hoisted_15 = { class: "request-form__footer--actions" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Alert = _resolveComponent("Alert")
  const _component_CustomConfirmDialog = _resolveComponent("CustomConfirmDialog")
  const _component_Button = _resolveComponent("Button")
  const _component_DoctorItemOptions = _resolveComponent("DoctorItemOptions")
  const _component_DoctorScheduled = _resolveComponent("DoctorScheduled")
  const _component_Textarea = _resolveComponent("Textarea")
  const _component_FileList = _resolveComponent("FileList")
  const _component_FileUploader = _resolveComponent("FileUploader")
  const _component_Doctors = _resolveComponent("Doctors")
  const _component_PageFrame = _resolveComponent("PageFrame")
  const _component_Form = _resolveComponent("Form")

  return (_openBlock(), _createBlock("main", null, [
    _createVNode("section", _hoisted_1, [
      (!_ctx.state.isLoading)
        ? (_openBlock(), _createBlock(_component_Form, {
            key: 0,
            class: "second-opinion__request__form",
            action: "",
            method: "",
            onSubmit: _ctx.saveConfirm
          }, {
            default: _withId(() => [
              (!!_ctx.alert.content)
                ? (_openBlock(), _createBlock(_component_Alert, {
                    key: 0,
                    alert: _ctx.alert,
                    isConfirm: "true",
                    "onUpdate:clear": _cache[1] || (_cache[1] = ($event: any) => (_ctx.alert.content = ''))
                  }, null, 8, ["alert"]))
                : _createCommentVNode("", true),
              _createVNode(_component_CustomConfirmDialog, { group: "save" }),
              _createVNode(_component_CustomConfirmDialog, {
                group: "confirm",
                isConfirm: true
              }),
              _createVNode(_component_PageFrame, { class: "form__content" }, {
                title: _withId(() => [
                  _createTextVNode(_toDisplayString(_ctx.state.pageType === _ctx.PageTypes.QUICK ? _ctx.t("quick") : "") + " " + _toDisplayString(_ctx.t("edit requested data")), 1)
                ]),
                content: _withId(() => [
                  _createVNode("div", _hoisted_2, [
                    (_ctx.state.page === _ctx.PageStates.PURPOSE)
                      ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                          (
                    !!_ctx.doctors.selectedDoctor &&
                      _ctx.doctors.selectedDoctor.length > 0 &&
                      _ctx.state.pageType === _ctx.PageTypes.NORMAL
                  )
                            ? (_openBlock(), _createBlock(_component_DoctorItemOptions, {
                                key: 0,
                                doctor: _ctx.doctors.selectedDoctor[0],
                                isProfile: true,
                                class: "selected-doctor"
                              }, {
                                button: _withId(() => [
                                  _createVNode(_component_Button, {
                                    class: "-button",
                                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.state.page = _ctx.PageStates.DOCTOR))
                                  }, {
                                    default: _withId(() => [
                                      _createTextVNode(_toDisplayString(_ctx.t("change docor")), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["doctor"]))
                            : _createCommentVNode("", true),
                          _createVNode("div", _hoisted_3, [
                            (_ctx.state.pageType !== _ctx.PageTypes.QUICK)
                              ? (_openBlock(), _createBlock(_component_DoctorScheduled, {
                                  key: 0,
                                  purpose: _ctx.state.purpose,
                                  timeList: _ctx.timeList,
                                  isEditable: _ctx.isEditable,
                                  doctorScheduled: _ctx.doctorScheduled,
                                  required: true,
                                  isLine: false
                                }, null, 8, ["purpose", "timeList", "isEditable", "doctorScheduled"]))
                              : _createCommentVNode("", true),
                            _createVNode("div", _hoisted_4, [
                              _createVNode("label", _hoisted_5, [
                                _createTextVNode(_toDisplayString(_ctx.t("input chief complaint")) + " ", 1),
                                _createVNode("span", _hoisted_6, " (" + _toDisplayString(_ctx.t("required")) + ")", 1)
                              ]),
                              _createVNode(_component_Textarea, {
                                id: "purpose",
                                modelValue: _ctx.state.purpose.other,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.state.purpose.other = $event)),
                                rows: 12,
                                cols: 36
                              }, null, 8, ["modelValue"])
                            ])
                          ]),
                          _createVNode("div", _hoisted_7, [
                            _createVNode("label", _hoisted_8, _toDisplayString(_ctx.t("attach files")), 1),
                            (_ctx.state.purpose.files && _ctx.state.purpose.files.length > 0)
                              ? (_openBlock(), _createBlock(_component_FileList, {
                                  key: 0,
                                  class: "upload-files",
                                  list: _ctx.state.purpose.files,
                                  onDeletedFile: _ctx.deletedFile,
                                  id: _ctx.state.id,
                                  requestKind: _ctx.RequestKindTypes.SecondOpinion
                                }, null, 8, ["list", "onDeletedFile", "id", "requestKind"]))
                              : _createCommentVNode("", true),
                            _createVNode(_component_FileUploader, {
                              ref: "fileUploader$",
                              isEditable: true,
                              onProgress: _ctx.filesProgress,
                              isAllowVideo: true,
                              isAllowZip: true,
                              url: _ctx.url,
                              class: "file-uploader"
                            }, null, 8, ["onProgress", "url"])
                          ])
                        ], 64))
                      : (_openBlock(), _createBlock(_component_Doctors, {
                          key: 1,
                          pDoctors: _ctx.doctors,
                          "onUpdate:pDoctors": _cache[4] || (_cache[4] = ($event: any) => (_ctx.doctors = $event)),
                          onSelectedDoctor: _ctx.onSelectedDoctor,
                          possibleTypes: _ctx.PossibleTypes.SECOND_OPINION,
                          doctorKey: _ctx.state.purpose.doctorKey?.valueOf(),
                          isEditable: true,
                          ref: "doctors$"
                        }, null, 8, ["pDoctors", "onSelectedDoctor", "possibleTypes", "doctorKey"]))
                  ])
                ]),
                footer: _withId(() => [
                  (!!_ctx.doctors.selectedDoctor && _ctx.doctors.selectedDoctor.length > 0)
                    ? (_openBlock(), _createBlock("div", _hoisted_9, [
                        _createVNode("div", _hoisted_10, [
                          _createVNode("span", _hoisted_11, _toDisplayString(_ctx.doctors.selectedDoctor[0].FacilityName) + " " + _toDisplayString(_ctx.doctors.selectedDoctor[0].DeptName), 1),
                          _createVNode("span", _hoisted_12, _toDisplayString(_ctx.doctors.selectedDoctor[0].DoctorName), 1)
                        ]),
                        _createVNode("div", _hoisted_13, [
                          _createVNode("span", {
                            class: ["label -medium", { '-invalid': !_ctx.state.purpose.date }]
                          }, _toDisplayString(_ctx.t("select desired date/time")), 3),
                          _createVNode("span", _hoisted_14, _toDisplayString(!!_ctx.state.purpose.date ? _ctx.selectDate : "-") + " " + _toDisplayString(!!_ctx.state.purpose.time ? " / " + _ctx.state.purpose.time : ""), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                action: _withId(() => [
                  _createVNode("div", _hoisted_15, [
                    (_ctx.state.page === _ctx.PageStates.PURPOSE)
                      ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                          _createVNode(_component_Button, {
                            class: "-button -grey3",
                            type: "button",
                            onClick: _ctx.goBack
                          }, {
                            default: _withId(() => [
                              _createTextVNode(_toDisplayString(_ctx.t("cancel")), 1)
                            ]),
                            _: 1
                          }, 8, ["onClick"]),
                          _createVNode(_component_Button, {
                            class: "-button -royalBlue",
                            type: "submit"
                          }, {
                            default: _withId(() => [
                              _createTextVNode(_toDisplayString(_ctx.t("do save")), 1)
                            ]),
                            _: 1
                          })
                        ], 64))
                      : _createCommentVNode("", true),
                    (_ctx.state.page === _ctx.PageStates.DOCTOR)
                      ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                          _createVNode(_component_Button, {
                            class: "-button -grey3",
                            type: "button",
                            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.state.page = _ctx.PageStates.PURPOSE))
                          }, {
                            default: _withId(() => [
                              _createTextVNode(_toDisplayString(_ctx.t("previous")), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Button, {
                            class: "-button -royalBlue",
                            onClick: _cache[6] || (_cache[6] = ($event: any) => {
                    _ctx.changedDoctor();
                    _ctx.state.page = _ctx.PageStates.PURPOSE;
                  })
                          }, {
                            default: _withId(() => [
                              _createTextVNode(_toDisplayString(_ctx.t("do change")), 1)
                            ]),
                            _: 1
                          })
                        ], 64))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["onSubmit"]))
        : _createCommentVNode("", true)
    ])
  ]))
})